// /* global fetch */
//
// import { isSlowDeviceUtil } from '../../device/is-slow'
// import { logUtil } from 'packages/src'
// // import { logUtil } from 'packages/src'
//
// //
//
// const QUEUE_DELAY = isSlowDeviceUtil()
//   ? 300
//   : 0
// const promiseCallbacks = []
// let requestsDelayTimerId = null
//
// async function process () {
//   logUtil('fetch')
//     .debug('process')
//   logUtil('fetch')
//     .debug('length: ', promiseCallbacks.length)
//   clearTimeout(requestsDelayTimerId)
//   requestsDelayTimerId = null
//   if (!promiseCallbacks.length) {
//     return
//   }
//   const promiseCallback = promiseCallbacks[0]
//   const response = await promiseCallback()
//   requestsDelayTimerId = setTimeout(process, QUEUE_DELAY)
//   promiseCallbacks.shift()
//   return response
// }
//
// function queue (promiseCallback) {
//   promiseCallbacks.push(promiseCallback)
//   if (promiseCallbacks.length === 1) {
//     process()
//   }
// }
//
// function timeout (timeoutMs, promise) {
//   return new Promise((resolve, reject) => {
//     logUtil('fetch')
//       .debug('start')
//     const timerId = setTimeout(() => {
//       reject(new Error('timeout'))
//       logUtil('fetch')
//         .debug('timeout')
//     }, timeoutMs)
//     promise
//       .then((res) => {
//         logUtil('fetch')
//           .debug('done')
//         resolve(res)
//       })
//       .catch((res) => {
//         logUtil('fetch')
//           .debug('error')
//         reject(res)
//       })
//       .finally(() => clearTimeout(timerId))
//   })
// }
//
// function fetchNetworkUtil (endpoint, options, timeoutMs = 20000) {
//   return new Promise(resolve => {
//     queue(() => resolve(timeout(timeoutMs, fetch(endpoint, options))))
//   })
// }
//
// export default fetchNetworkUtil

/* global fetch */

import { logUtil } from 'packages/src'

const FETCH_REQUEST_TIMEOUT = 30000 // 30 seconds

function timeout (timeoutMs, promise) {
  return new Promise((resolve, reject) => {
    const timerId = setTimeout(() => {
      reject(new Error('timeout'))
    }, timeoutMs)
    promise
      .then((res) => {
        clearTimeout(timerId)
        resolve(res)
      })
      .catch((res) => {
        clearTimeout(timerId)
        reject(res)
      })
  })
}

export default function fetchNetworkUtil (endpoint, options,
  timeoutMs = FETCH_REQUEST_TIMEOUT
) {
  logUtil('fetchNetworkUtil').debug(`endpoint: ${endpoint}, options: `, options)
  // logUtil('fetchNetworkUtil')
  //   .debug('endpoint: ', endpoint, 'options: ', options)
  return timeout(timeoutMs, fetch(endpoint, options))
}
